import { yupResolver } from '@hookform/resolvers/yup';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword, ResetPasswordRequest } from 'wisestep-api';
import {
  Item,
  WisestepLogo,
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsButton,
  ControlledTextInput,
  WsTypoColors,
} from 'wisestep-base';
import * as Yup from 'yup';
import { object, string } from 'yup';

import { AuthLayout, WsLink } from '../../../components';

const validationSchema = object().shape({
  newPassword: string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  confirmPassword: string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
});
interface RestFormType {
  newPassword: string;
  confirmPassword: string;
}
const ResetPasswordForm = () => {
  const [searchParams] = useSearchParams();
  const [isReset, setIsReset] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const navigate = useNavigate();

  const key = searchParams.get('key');
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: {},
  };

  const methods = useForm<RestFormType>(formOptions);

  const { handleSubmit } = methods;

  const onFormSubmit = async (data: RestFormType) => {
    const request: ResetPasswordRequest = {
      key: key,
      newPassword: data.newPassword,
    };
    try {
      await resetPassword(request);
      setIsReset(true);
    } catch (error) {
      setIsError(true);
    }
  };

  return (
    <AuthLayout>
      <FormProvider {...methods}>
        {!isReset ? (
          <Item>
            <form onSubmit={handleSubmit(onFormSubmit)}>
              <Stack alignItems="center" mb={3} spacing={4} p={3} mx={10}>
                <WisestepLogo />
                <WsTypography variant={WsTypoVariants.TITLE}>Reset Password</WsTypography>
              </Stack>
              <Stack spacing={1} direction="column" width={'100%'}>
                <ControlledTextInput
                  name="newPassword"
                  labelText="New Password *"
                  type="password"
                  fullWidth
                  id="username"
                  placeholder="enter new password"
                  variant="outlined"
                  required
                  autoComplete="email"
                />
              </Stack>
              <Stack mt={1} spacing={1} direction="column">
                <ControlledTextInput
                  name={'confirmPassword'}
                  labelText="Enter Password *"
                  type="password"
                  fullWidth
                  id="password"
                  placeholder="confirm password"
                  variant="outlined"
                  required
                  autoComplete="password"
                />
              </Stack>
              <Stack mt={2}>
                {isError && (
                  <Stack my={3} sx={{ backgroundColor: WsColors.Red300 }} p={3}>
                    <WsTypography variant={WsTypoVariants.BODY1}>
                      Your password couldn&apos;t be reset. Remember a password request is only
                      valid for 24 hours
                    </WsTypography>
                  </Stack>
                )}
                <WsButton variant="contained" size="large" fullWidth type="submit">
                  Reset Password
                </WsButton>
              </Stack>
              <Stack justifyContent="center" alignItems="center" direction="row" spacing={1}>
                <WsLink to="/">
                  <WsTypography
                    variant={WsTypoVariants.BODY1}
                    color={WsTypoColors.PRIMARY}
                    cursor="pointer"
                  >
                    Log in
                  </WsTypography>
                </WsLink>
                <WsTypography variant={WsTypoVariants.BODY1}>/</WsTypography>
                <WsLink to="/sign-up">
                  <WsTypography
                    variant={WsTypoVariants.BODY1}
                    color={WsTypoColors.PRIMARY}
                    cursor="pointer"
                  >
                    Sign Up
                  </WsTypography>
                </WsLink>
              </Stack>
            </form>
          </Item>
        ) : (
          <Item sx={{ padding: 13 }}>
            <Stack alignItems="center" mb={3}>
              <WisestepLogo />
            </Stack>
            <Stack mt={3} sx={{ backgroundColor: WsColors.TheBlues200 }} p={3}>
              <WsTypography variant={WsTypoVariants.BODY1}>Your Password is Updated.</WsTypography>
              <WsButton onClick={() => navigate('/')} variant="text">
                Sign-In
              </WsButton>
            </Stack>
          </Item>
        )}
      </FormProvider>
    </AuthLayout>
  );
};
export default ResetPasswordForm;
